import React from "react";
import { useWorldContract } from "../../../mud/useWorldContract";
import { Severity } from "@eveworld/types";
import configureSmartGate from "../../systemCalls/handleConfigureSmartGate";
import { EveButton } from "@eveworld/ui-components";
import { useNotification } from "@eveworld/contexts";

interface ButtonProps {
  AssemblyId: string;
}

const ButtonSetContractGate: React.FC<ButtonProps> = ({ AssemblyId }) => {
  const { worldContract } = useWorldContract();
  const { notify } = useNotification();

  const handleSetContractGate = async (SmartObjectId: string) => {
    const txHash = await configureSmartGate({
      worldContract,
      smartObjectId: SmartObjectId,
      systemId:
        "0x73795461707469636300000000000000536d6172744761746553797374656d00",
    });
    if (txHash) {
      notify({ type: Severity.Success, txHash });
    } else {
      notify({
        type: Severity.Error,
        message: "Transaction failed to execute",
      });
    }
  };

  return (
    <EveButton
      typeClass="primary"
      onClick={() => handleSetContractGate(AssemblyId)}
    >
      Set Contract
    </EveButton>
  );
};

export default React.memo(ButtonSetContractGate);
